<h2 mat-dialog-title>Refer Back — {{ patientName() }}</h2>

<mat-dialog-content>
  <p class="dialog-description">
    Send a clinical snapshot back to the referring doctor.
    Problem list and medications are automatically included.
  </p>

  @if (isLoading()) {
    <div class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Loading patient data...</span>
    </div>
  } @else {
    <div class="snapshot-info">
      <div class="auto-included">
        <mat-icon>check_circle</mat-icon>
        <span>Problem list — auto-included</span>
      </div>
      <div class="auto-included">
        <mat-icon>check_circle</mat-icon>
        <span>Medications — auto-included</span>
      </div>
    </div>

    <!-- Comment Selection -->
    @if (hasComments()) {
      <div class="section">
        <h3>Include a comment (optional)</h3>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Select a comment</mat-label>
          <mat-select [value]="selectedCommentId()" (selectionChange)="onCommentSelected($event.value)">
            <mat-option [value]="null">None</mat-option>
            @for (comment of patientComments(); track comment.id) {
              <mat-option [value]="comment.id">
                {{ comment.commentTemplate?.description || 'Comment' }} — {{ formatDate(comment.createdDate) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- Upload Selection -->
    @if (hasUploads()) {
      <div class="section">
        <h3>Include uploads (optional)</h3>
        <div class="upload-list">
          @for (upload of patientUploads(); track upload.id) {
            <mat-checkbox
              [checked]="isUploadSelected(upload.id)"
              (change)="toggleUpload(upload.id, $event.checked)">
              <div class="upload-item">
                <mat-icon>attach_file</mat-icon>
                <span>{{ upload.fileName }}</span>
              </div>
            </mat-checkbox>
          }
        </div>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()"
    [disabled]="isLoading() || isSubmitting()">
    @if (isSubmitting()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Send Snapshot
    }
  </button>
</mat-dialog-actions>
